import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import EngagementRings from "./pages/EngagementRings";
import WeddingBands from "./pages/WeddingBands";
import Lifestyle from "./pages/Lifestyle";
import InStock from "./pages/InStock";
import CustomDesign from "./pages/CustomDesign";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import About from "./pages/About";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/engagement-rings" element={<EngagementRings />} />
          <Route path="/wedding-bands" element={<WeddingBands />} />
          <Route path="/lifestyle" element={<Lifestyle />} />
          <Route path="/in-stock" element={<InStock />} />
          <Route path="/custom-design" element={<CustomDesign />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
